<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-10 pl-3 pr-3">
            <h2 class="ml-0 mb-0 mt-0">
                <div class="d-flex flex-wrap justify-content-between">
                    <div class="breadcrumbactive">
                        <div>
                            <span>Campaigns</span>
                            <span><router-link to="/campaign/sms/campaignSmsListView/" class="text-white pl-2 text-line">SMS</router-link></span>
                            <div>View Campaign</div>
                            <!-- <div>{{ $route.params.id == 'new' ? 'Create Deals' : 'Edit Deals'}}</div> -->
                        </div>
                    </div>
                    <div class="d-flex flex-wrap align-items-center" v-if="!ajaxCallInProgress">
                        <button v-if="userPermissions.campaigns.permitted_actions.edit && campaign_status != 'approved'" class="btn btn-new-save btn-new-success mr-5" @click="goToEdit()"><img src="/static/images/images-new-theme/icons/edit-white.png" width="15" style="margin-right: 8px;">Edit</button>
                        <span class="fs-16 text-capitalize"
                        :class="{
                            'text-pending':campaign_details.status == 'pending',
                            'text-approved':campaign_details.status == 'approved',
                            'text-new-danger':campaign_details.status == 'rejected'}"
                        >Status : {{campaign_details.status}}</span>
                    </div>
                </div>
            </h2>
            <!-- <div class="d-flex align-items-center justify-content-center h-100" v-if="ajaxCallInProgress">
                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
            </div> -->
            <div class="start-overflow">
                <div class="create-company-container w-100">
                    <div class="main-div">
                        <div class="px-10 py-4" v-if="campaign_details.status == 'rejected'">
                            <div class="p-2" style="border: 1px solid #e64646;border-radius:10px;height:100px;">
                                <span class="fs-14 fw-500 text-new-danger">Reason for Rejection</span>
                                <div class="pt-2">
                                    <span class="fs-14">{{campaign_details.rejected_reason}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="create-company-header d-flex align-items-center justify-content-between">
                            <span class="fs-14  pl-4 text-white ml-8 fw-500">Campaign Information</span>
                            <!-- <span class="pointer pt-2" @click="showDealInfo">
                                <i v-if="!show_deals_details" class="icon-chevron-double-up text-white fw-500 fs-20"></i>
                                <i v-else class="icon-chevron-double-down text-white fw-500 fs-20"></i>
                            </span> -->
                        </div>
                        <div>
                            <div class="mt-6 px-10" >
                                <div class="pt-6 pl-6 pr-6 pb-2">
                                    <div class="row">
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="w-100">
                                                <span class="input-label">Campaign Name<sup class="fs-14 pl-1 text-danger">*</sup></span>
                                                <div class="d-flex align-content-center mt-2">
                                                    <input type="text" name="campaign_name" disabled v-validate="'required'" class="input-field input-width" v-model="createJson.campaign_name" placeholder="Campaign Name" />
                                                </div>
                                                <div class="text-right pr-10">
                                                    <span class="float-left text-danger mb-3" v-show="errors.has('campaign_name')">{{errors.first('campaign_name')}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="w-100">
                                                <span class="input-label">Author Name<sup class="fs-14 pl-1 text-danger">*</sup></span>
                                                <div class="d-flex align-content-center mt-2">
                                                    <input type="text" name="author_name" disabled class="input-field input-width" v-validate="'required'" v-model="createJson.author_name" placeholder="Author Name" />
                                                    <span class="mt-4 ml-1">
                                                        <span class="mt-3"><i class="icon text-green icon-check-circle"></i></span>
                                                    </span>
                                                </div>
                                                <div class="text-right pr-10">
                                                    <span class="float-left text-danger mb-3" v-show="errors.has('author_name')">Author Name is Required</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="w-100">
                                                <span class="input-label">Author's Email Address<sup class="fs-14 pl-1 text-danger">*</sup></span>
                                                <div class="d-flex align-content-center mt-2">
                                                    <input type="text" name="authors_email" disabled class="input-field input-width" v-validate="'required'" v-model="createJson.author_email" placeholder="Author's Email" />
                                                    <span class="mt-4 ml-1">
                                                        <span class="mt-3"><i class="icon text-green icon-check-circle"></i></span>
                                                    </span>
                                                </div>
                                                <div class="text-right pr-10">
                                                    <span class="float-left text-danger mb-3" v-show="errors.has('authors_email')">Author's Email is Required</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-5">
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="d-flex align-items-center">
                                                <div class="w-100">
                                                    <span class="input-label">Industry Type<sup class="fs-14 pl-1 text-danger">*</sup></span>
                                                    <multiselect v-validate="'required'"
                                                        class="diginew-multiselect dis-bg-color new-align-multi customer-multiselect no-default-icon down-arrow mt-2"
                                                        :searchable="true" :options="industries" name="industry_type"
                                                        :disabled="true"
                                                        v-model="createJson.industry_type" placeholder="Select Industry Type">
                                                        <template slot="noOptions">
                                                            <div class="text-secondary text-center fw-600">Industry Types not found
                                                            </div>
                                                        </template>
                                                        <template slot="noResult">
                                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                                        </template>
                                                    </multiselect>
                                                    <div class="text-right pr-10">
                                                        <span class="float-left text-danger mb-3"
                                                            v-show="errors.has('industry_type')">Industry Type is Required</span>
                                                    </div>
                                                </div>
                                                <!-- <span class="mt-8">
                                                    <i class="icon icon-check-circle fs-30 ml-2 text-green"></i>
                                                </span> -->
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="w-100">
                                                <span class="input-label">Campaign Type<sup class="fs-14 pl-1 text-danger">*</sup></span>
                                                <div class="d-flex align-content-center mt-2">
                                                    <input type="text" name="campaign_type" disabled class="input-field input-width" v-validate="'required'" v-model="createJson.campaign_type" placeholder="Campaign Type" />
                                                    <span class="mt-4 ml-1">
                                                        <span class="mt-3"><i class="icon text-green icon-check-circle"></i></span>
                                                    </span>
                                                </div>
                                                <div class="text-right pr-10">
                                                    <span class="float-left text-danger mb-3" v-show="errors.has('campaign_type')">Campaign Type is Required</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="row">
                                                <div class="col-lg-8 col-md-8 col-sm-6">
                                                    <span class="input-label">
                                                        Start Date <sup class="fs-14 pl-1 text-danger">*</sup>
                                                    </span>
                                                    <div class="d-flex align-items-center mt-2">
                                                        <date-picker v-model="createJson.start_date" name="start_date"
                                                            :not-before="new Date()"
                                                            :disabled="true"
                                                            class="meetinfdatetime mx-left calendar-edit-per mr-1"
                                                            format="YYYY-MM-DD" value-type="format" type="date" lang="en"
                                                            @change="resetEndDateTime()"
                                                            :clearable="false" :editable="false" confirm confirm-text="APPLY">
                                                        </date-picker>
                                                        <span class="mt-3"><i class="icon text-green icon-check-circle"></i></span>
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger" v-if="is_start_date">
                                                        Start Date is required.
                                                    </span>
                                                </div>
                                                <div class="col-lg-4 col-md-4 col-sm-6 pl-1">
                                                    <span class="input-label">
                                                      Time <sup class="fs-14 pl-1 text-danger">*</sup>
                                                    </span>
                                                    <div class="d-flex align-items-center mr-6">
                                                        <!-- <date-picker
                                                            type="time"
                                                            v-model="createJson.start_time"
                                                            name="start_time"
                                                            class="meetinfdatetime mx-left calendar-edit-per mr-1 calendar-down-arrow-grey no-down-arrow-autofill"
                                                            format="HH:mm"
                                                            placeholder="HH:MM"
                                                            value-type="format"
                                                            lang="en"
                                                            :clearable="false"
                                                            :editable="false"
                                                            confirm
                                                            confirm-text="APPLY">
                                                        </date-picker> -->
                                                        <el-select v-validate="'required'" disabled name="start_time" class="mt-2 schedule_time" v-model="createJson.start_time" style="border-radius: 6px;border: 1px solid rgb(92 92 92) !important;"
                                                        placeholder="Start Time" :popper-append-to-body="false" @change="CheckDate(), resetEndDateTime()">
                                                            <el-option
                                                                v-for="(item, index) in start_date_time_format"
                                                                :key="index"
                                                                :label="item"
                                                                :value="item">
                                                            </el-option>
                                                        </el-select>
                                                        <!-- <span class="mt-3"><i class="icon text-green icon-check-circle"></i></span> -->
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger" v-if="is_start_date">Start Time is required.</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-5">
                                        <div class="col-lg-4 col-md-6 col-sm-12">
                                            <div class="row">
                                                <div class="col-lg-8 col-md-8 col-sm-6">
                                                    <span class="input-label">
                                                        End Date <sup class="fs-14 pl-1 text-danger">*</sup>
                                                    </span>
                                                    <div class="d-flex align-items-center mt-2">
                                                        <date-picker v-model="createJson.end_date" v-validate="'required'"
                                                        name="closure_date" class="meetinfdatetime mx-left calendar-edit-per mr-1 calendar-edit-per mr-1 "
                                                        format="YYYY-MM-DD" value-type="format" type="date" lang="en"
                                                        :disabled="true"
                                                        :clearable="false"
                                                        :default-value="current_date"
                                                        :not-before="createJson.start_date"
                                                        @change="CheckDate()"
                                                        :editable="false" confirm confirm-text="APPLY"></date-picker>
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger" v-if="is_end_date && createJson.end_date == ''"> End Date is required.</span>
                                                </div>
                                                <div class="col-lg-4 col-md-4 col-sm-6 pl-1">
                                                    <span class="input-label">
                                                        Time  <sup class="fs-14 pl-1 text-danger">*</sup>
                                                    </span>
                                                    <div class="d-flex align-items-center">
                                                        <!-- <date-picker
                                                        v-model="createJson.end_time"
                                                        type="time" name="end_time"
                                                        v-validate="'required'"
                                                        class="meetinfdatetime mx-left calendar-edit-per mr-1 calendar-down-arrow-grey hide-seconds date-picker-clock-svg-icon"
                                                        format="HH:mm"
                                                        :minute-step="1"
                                                        placeholder="HH:MM"
                                                        value-type="format"
                                                        lang="en"
                                                        :clearable="false"
                                                        :editable="false"
                                                        confirm
                                                        confirm-text="APPLY">
                                                    </date-picker> -->
                                                        <el-select v-validate="'required'" disabled name="end_time" class="mt-2 schedule_time dis-bg-color" v-model="createJson.end_time" style="border-radius: 6px;border: 1px solid rgb(92 92 92) !important;"
                                                        placeholder="End Time" @click="CheckDate" :popper-append-to-body="false">
                                                            <el-option
                                                                v-for="(item, index) in end_date_time_format"
                                                                :key="index"
                                                                :label="item"
                                                                :value="item">
                                                            </el-option>
                                                        </el-select>
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger" v-if="is_end_time && createJson.end_time == ''">
                                                        End Time is required.
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <!-- <div class="row">
                                                <div class="col-lg-8 col-md-8 col-sm-6"> -->
                                                    <span class="text-secondary whiteSpace fs-14 vselectLabel fw-600">
                                                        Recurrence
                                                    </span>
                                                    <div class="d-block align-items-center mt-1 mr-6">
                                                        <multiselect v-validate="'required'"
                                                            class="diginew-multiselect dis-bg-color new-align-multi customer-multiselect no-default-icon down-arrow mt-2"
                                                            :disabled="true"
                                                            :searchable="true" :options="recurrencedays" name="recurrence_days"
                                                            v-model="createJson.recurrence_days" placeholder="Select">
                                                            <template slot="noOptions">
                                                                <div class="text-secondary text-center fw-600">Recurrence not found
                                                                </div>
                                                            </template>
                                                            <template slot="noResult">
                                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                                            </template>
                                                        </multiselect>
                                                        <!-- <div class="text-right pr-10">
                                                            <span class="float-left text-danger mb-3"
                                                                v-show="errors.has('recurrence_days')">Recurrence is Required</span>
                                                        </div> -->
                                                    </div>
                                                <!--</div>
                                                 <div class="col-lg-4 col-md-4 col-sm-6 pl-2">
                                                    <span class="text-secondary whiteSpace fs-14 vselectLabel fw-600" style="visibility: hidden;">
                                                        Recurrence
                                                    </span>
                                                    <div class="d-block align-items-center mt-1">
                                                        <multiselect v-validate="'required'"
                                                            class="diginew-multiselect new-align-multi customer-multiselect no-default-icon down-arrow mt-2"
                                                            :searchable="true" :options="recurrencenumbers" name="recurrence_nos"
                                                            v-model="recurrence_nos" placeholder="Select">
                                                            <template slot="noOptions">
                                                                <div class="text-secondary text-center fw-600">Recurrence not found
                                                                </div>
                                                            </template>
                                                            <template slot="noResult">
                                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                                            </template>
                                                        </multiselect>
                                                        <div class="text-right pr-10">
                                                            <span class="float-left text-danger mb-3"
                                                                v-show="errors.has('recurrence_nos')">Recurrence is Required</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>-->
                                        </div>
                                        <div class="col-lg-4 col-md-6 col-sm-12">
                                            <div class="row">
                                                <div class="col-lg-3 col-md-3 col-sm-6">
                                                    <span class="text-secondary whiteSpace fs-14 vselectLabel fw-600">
                                                        Budget
                                                    </span>
                                                    <div class="d-flex align-items-center mt-2">
                                                        <input type="text" disabled name="currency" v-model="createJson.currency" class="input-field input-width text-center"  placeholder="$" />
                                                    </div>
                                                </div>
                                                <div class="col-lg-9 col-md-9 col-sm-6 pl-2">
                                                    <span class="text-secondary whiteSpace fs-14 vselectLabel fw-600" style="visibility: hidden;">
                                                        Budget
                                                    </span>
                                                    <div class="d-flex align-items-center mt-2 mr-6">
                                                        <input type="text" name="budget" disabled class="input-field input-width" @keypress="isNumber($event)" v-model="createJson.budget" placeholder="Enter Budget Value" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-5">
                                        <div class="col-lg-6 col-md-6 col-sm-12">
                                            <span class="text-secondary whiteSpace fs-14 vselectLabel fw-600">
                                                Description
                                            </span>
                                            <div class="d-flex align-items-center">
                                                <textarea-autosize class="digi-textarea white-background bordered" disabled maxlength="500" placeholder="Add Description" v-model="createJson.add_description" style="height: 8em; overflow: auto;" />
                                            </div>
                                            <div class="text-right mt-1">
                                                <span class="input-field-length float-right">{{ 500 - createJson.add_description.length }}/500</span>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-12">
                                            <span class="text-secondary whiteSpace fs-14 vselectLabel fw-600">
                                                Recipients <sup class="fs-14 pl-1 text-danger">*</sup>
                                                <!-- <button class="float-right mr-8 add-button" @click="contactsPop()">
                                                    Add+
                                                </button> -->
                                            </span>
                                            <div class="d-flex align-items-center mt-2">
                                                <div class="recipients-box">
                                                    <multiselect
                                                        class="diginew-multiselect-longshort sms-rec-list greyblack no-default-icon"
                                                        name="recipients"
                                                        disabled
                                                        v-validate="'required'"
                                                        @search-change="searchCustomerInside"
                                                        @open="searchCustomerInside"
                                                        @close="search_term = ''"
                                                        :loading="isLoading"
                                                        v-model="createJson.recipient_details"
                                                        :searchable="true" :block-keys="['Tab']"
                                                        :preserve-search="true"
                                                        placeholder="Select Recipients"
                                                        :options="optionsRecipients"
                                                        :multiple="true"
                                                        :close-on-select="false"
                                                        :show-labels="false"
                                                        :clear-on-select="true"
                                                        :hide-selected="false" :taggable="true"
                                                        label="name" track-by="email"
                                                        @tag="addCustomer">
                                                        <template slot="tag"
                                                            slot-scope="{ option}">
                                                            <span class="custom__tag">
                                                                <span>{{ option.name }}</span>
                                                            </span>
                                                        </template>
                                                        <template slot="afterList">
                                                            <div
                                                                v-observe-visibility="reachedEndOfListCustomer" />
                                                        </template>
                                                        <template slot="noOptions">
                                                            <div
                                                                class="text-secondary text-center fw-600">
                                                                List is Empty</div>
                                                        </template>
                                                        <template slot="noResult">
                                                            <div
                                                                class="text-secondary text-center fw-600">
                                                                No Results Found</div>
                                                        </template>
                                                    </multiselect>
                                                    <div class="text-right mt-1">

                                                        <span class="float-left text-danger mb-3" v-show="errors.has('recipients')">Recipients are Required</span>
                                                    </div>
                                                </div>
                                                <span class="mt-0 ml-2">
                                                    <img src="/static/images/person-add-green.svg" style="width: 16px; margin-top: -60px !important"/>
                                                </span>
                                                <sup class="rec-count" style="color:#008a63;font-size: 11px;font-weight: 600;">{{ this.createJson.recipient_details.length }}</sup>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-5">
                                        <div class="col-lg-12 col-md-12 col-sm-12">
                                            <span class="text-secondary whiteSpace fs-14 vselectLabel fw-600">
                                                Add Campaign Message
                                            </span>
                                            <div class="d-block mt-3">
                                                <div class="row">
                                                    <div class="col-lg-1 col-md-1 col-sm-12 mt-2 pr-0">
                                                        <span class="fs-14 vselectLabel fw-400">
                                                            Add URL<sup class="fs-14 pl-1 text-danger">*</sup>
                                                        </span>
                                                    </div>
                                                    <div class="col-lg-6 col-md-6 col-sm-12 pl-0">
                                                        <input type="url" name="sms_url" disabled class="input-field input-width" v-validate="{url: {require_protocol: true }}" data-vv-as="field" v-model="createJson.sms_url" placeholder="https://www.digicollect.com/" />
                                                    </div>
                                                    <div class="text-right mt-1">
                                                        <span class="float-left text-danger mb-3" v-show="errors.has('sms_url')">URL is Invalid</span>
                                                    </div>
                                                </div>
                                                <div class="text-right pr-10">
                                                    <span v-if="is_sms_url && createJson.sms_url == ''" class="d-flex justify-content-start text-danger mb-3 ml-25 mt-2">URL is Required</span>
                                                </div>
                                            </div>
                                            <div class="col-lg-2 col-md-2 col-sm-12 mt-8 pr-0 pl-0 mr-0">
                                                <span class="fs-14 vselectLabel fw-400">
                                                    Add Message<sup class="fs-14 pl-1 text-danger">*</sup>
                                                </span>
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <textarea-autosize class="digi-textarea white-background bordered" disabled name="add_message" v-validate="'required'" maxlength="160" placeholder="Add Message" v-model="createJson.add_message" style="height: 10em; overflow: auto;" />
                                            </div>
                                            <div class="text-right pr-10">
                                                <span class="float-left text-danger mb-3"
                                                    v-show="errors.has('add_message')">Message is Required</span>
                                            </div>
                                            <div class="text-right mt-1">
                                                <span class="input-field-length float-right">{{ 160 - createJson.add_message.length }}/160</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex flex-wrap align-items-center justify-content-center mb-4 mt-5">
                                <button v-if="campaign_status != 'pending'" class="btn btn-new-cancel" @click="gotoListView()">Close</button>
                                <button v-if="userPermissions.campaigns.permitted_actions.approval && campaign_status != 'rejected' && campaign_status != 'approved'" class="btn btn-new-reject" @click ="rejectPopUp">Reject</button>
                                <button v-if="userPermissions.campaigns.permitted_actions.approval && campaign_status != 'approved'" class="btn btn-new-approve ml-5" @click ="approveCampaigns()">Approve</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <reject-campaign v-if="openRejectPopUp" modal_name="rejectCampaign" @rejectCampaigns="rejectCampaigns" @cancelReject="closeReject"></reject-campaign>
        <sweet-modal ref="warning_modal" hide-close-button overlay-theme="dark" icon="warning">{{warning_msg}}</sweet-modal>
        <sweet-modal ref="success_modal" hide-close-button overlay-theme="dark" icon="success">{{success_msg}}</sweet-modal>
        <contacts-modal v-if="openContactsPopUp" :selectContacts="this.createJson.recipient_details" @selectedContacts="selectedContacts" modal_name="contactsPopUp" @hide-contacts-modal="closeContactsModal()"></contacts-modal>
    </div>
</template>
<script>
import { SweetModal } from 'sweet-modal-vue';
import moment from 'moment';
import customer from "../../mixins/customer"
import RejectCampaign from "./RejectCampaign";
import leads from "../../mixins/leads"
import campaign from "../../mixins/campaign"
import { EventBus } from '../../eventBus/nav-bar-event';
const ContactsModal = () => import("../Email/ContactsModal");
export default {
    data(){
        return {
            openRejectPopUp: false,
            approveButtonDisable: false,
            ajaxCallInProgress: false,
            openContactsPopUp: false,
            campaign_details: [],
            campaign_id: "",
            campaign_status: '',
            createJson:{
                campaign_name: "",
                author_name: "",
                author_email: "",
                industry_type: "",
                campaign_type: 'SMS',
                start_date: moment(new Date().toUTCString()).format("YYYY-MM-DD"),
                start_time: moment(new Date().toUTCString()).format("HH:mm"),
                end_date: "",
                end_time: "",
                recurrence_days: "",
                currency: "",
                recipient_details: [],
                //recurrence_nos: null,
                //recurrencenumbers: ["None", "Once", "Twice", "Thrice", "Every 4 hours", "Morning", "Evening"],
                budget: "",
                add_description: "",
                sms_url: "",
                add_message: "",
            },
            success_msg: '',
            warning_msg: '',
            is_start_date: false,
            is_end_date: false,
            is_end_time:false,
            is_sms_url: false,
            isLoading: false,
            optionsRecipients: [],
            recurrencedays: ["Daily", "Weekly", "Monthly"],
            industries: ["Accommodation and Food Services",
                "Administrative and Support, Waste Management and Remediation Services",
                "Agriculture, Forestry, Fishing and Hunting", "Arts, Entertainment and Recreation",
                "Construction", "Developer", "Educational Services", "EPC", "Finance and Insurance", "F&B",
                "Health Care and Social Assistance", "Information and Cultural Industries",
                "Management of Companies and Enterprises", "Manufacturing",
                "Mining, Quarrying, and Oil and Gast Extraction",
                "Other Services (except public administration)",
                "Professional, Scientific and Technical Services", "Public Administration",
                "Real Estate and Rental and Leasing", "Residential Installation", "Retail Trade", "Supplier",
                "Transportation and Warehousing",
                "Utilities", "Wholesale Trade", "Other Businesses"
            ],
            start_date_time_format: [
                '00:00',
                '00:30',
                '01:00',
                '01:30',
                '02:00',
                '02:30',
                '03:00',
                '03:30',
                '04:00',
                '04:30',
                '05:00',
                '05:30',
                '06:00',
                '06:30',
                '07:00',
                '07:30',
                '08:00',
                '08:30',
                '09:00',
                '09:30',
                '10:00',
                '10:30',
                '11:00',
                '11:30',
                '12:00',
                '12:30',
                '13:00',
                '13:30',
                '14:00',
                '14:30',
                '15:00',
                '15:30',
                '16:00',
                '16:30',
                '17:00',
                '17:30',
                '18:00',
                '18:30',
                '19:00',
                '19:30',
                '20:00',
                '20:30',
                '21:00',
                '21:30',
                '22:00',
                '22:30',
                '23:00',
                '23:30',
            ],
            end_date_time_format:[
                '00:00',
                '00:30',
                '01:00',
                '01:30',
                '02:00',
                '02:30',
                '03:00',
                '03:30',
                '04:00',
                '04:30',
                '05:00',
                '05:30',
                '06:00',
                '06:30',
                '07:00',
                '07:30',
                '08:00',
                '08:30',
                '09:00',
                '09:30',
                '10:00',
                '10:30',
                '11:00',
                '11:30',
                '12:00',
                '12:30',
                '13:00',
                '13:30',
                '14:00',
                '14:30',
                '15:00',
                '15:30',
                '16:00',
                '16:30',
                '17:00',
                '17:30',
                '18:00',
                '18:30',
                '19:00',
                '19:30',
                '20:00',
                '20:30',
                '21:00',
                '21:30',
                '22:00',
                '22:30',
                '23:00',
                '23:30',
            ],
        }
    },
    mixins: [customer,leads,campaign],
    components:{
        ContactsModal,
        SweetModal,
        RejectCampaign
    },
    methods:{
        closeReject(){
            this.openRejectPopUp = false;
        },
        rejectPopUp(){
            this.openRejectPopUp = true;
            setTimeout(()=>{
                this.$modal.show("rejectCampaign")
            },500)
        },
        async approveCampaigns(reason){
            try{
                let params = {
                    campaign_id: this.$route.params.id,
                    status: "approved",
                    reason: reason
                }
                let response = await this.callApproveRejectCampaignAPI(params)
                if (response.status_id == 1) {
                    this.success_msg = response.response
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.gotoListView();
                        this.$refs.success_modal.close();
                    }, 3000);
                } else {
                    this.warning_msg = response.reason
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            }catch(error){
                this.warning_msg = error.reason
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        async rejectCampaigns(reason){
            try {
                let params = {
                    campaign_id: this.$route.params.id,
                    status: "rejected",
                    reason: reason
                }
                let response = await this.callApproveRejectCampaignAPI(params)
                if (response.status_id == 1) {
                    this.success_msg = response.response
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.closeReject();
                        this.gotoListView();
                        this.$refs.success_modal.close();
                    }, 3000);
                } else {
                    this.warning_msg = response.reason
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            }catch(error){
                this.warning_msg = error.reason
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        goToEdit(){
            this.$router.push('/campaign/sms/createCampaignSms/'+ this.$route.params.id);
        },
        gotoListView(){
            this.$router.push({
                path: '/campaign/sms/campaignSmsListView/'
            })
        },
        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            }
        },
        resetEndDateTime(){
            this.createJson.end_date = '',
            this.createJson.end_time = ''
        },
        CheckDate(){
            if(this.createJson.start_date == this.createJson.end_date){
                var temp_start_date = ""
                if(parseInt(this.createJson.start_time.substring(3)) >= 0 && parseInt(this.createJson.start_time.substring(3)) < 30){
                    temp_start_date = this.createJson.start_time.slice(0,3) + '00'
                } else if(parseInt(this.createJson.start_time.substring(3)) >= 30){
                    temp_start_date = this.createJson.start_time.slice(0,3) + '30'
                }
                this.end_date_time_format = [
                    '00:00',
                    '00:30',
                    '01:00',
                    '01:30',
                    '02:00',
                    '02:30',
                    '03:00',
                    '03:30',
                    '04:00',
                    '04:30',
                    '05:00',
                    '05:30',
                    '06:00',
                    '06:30',
                    '07:00',
                    '07:30',
                    '08:00',
                    '08:30',
                    '09:00',
                    '09:30',
                    '10:00',
                    '10:30',
                    '11:00',
                    '11:30',
                    '12:00',
                    '12:30',
                    '13:00',
                    '13:30',
                    '14:00',
                    '14:30',
                    '15:00',
                    '15:30',
                    '16:00',
                    '16:30',
                    '17:00',
                    '17:30',
                    '18:00',
                    '18:30',
                    '19:00',
                    '19:30',
                    '20:00',
                    '20:30',
                    '21:00',
                    '21:30',
                    '22:00',
                    '22:30',
                    '23:00',
                    '23:30',
                ]
                let indx = this.end_date_time_format.indexOf(temp_start_date)
                this.end_date_time_format.splice(0,indx+1)
            } else {
                this.end_date_time_format = [
                    '00:00',
                    '00:30',
                    '01:00',
                    '01:30',
                    '02:00',
                    '02:30',
                    '03:00',
                    '03:30',
                    '04:00',
                    '04:30',
                    '05:00',
                    '05:30',
                    '06:00',
                    '06:30',
                    '07:00',
                    '07:30',
                    '08:00',
                    '08:30',
                    '09:00',
                    '09:30',
                    '10:00',
                    '10:30',
                    '11:00',
                    '11:30',
                    '12:00',
                    '12:30',
                    '13:00',
                    '13:30',
                    '14:00',
                    '14:30',
                    '15:00',
                    '15:30',
                    '16:00',
                    '16:30',
                    '17:00',
                    '17:30',
                    '18:00',
                    '18:30',
                    '19:00',
                    '19:30',
                    '20:00',
                    '20:30',
                    '21:00',
                    '21:30',
                    '22:00',
                    '22:30',
                    '23:00',
                    '23:30',
                ]
            }
        },
        selectedContacts(selected_contacts){
            this.createJson.recipient_details = []
            selected_contacts.forEach((el, el_index)=>{
                this.createJson.recipient_details.push(el)
            })
        },
        contactsPop(){
            this.openContactsPopUp = true;
            setTimeout(()=>{
                this.$modal.show("contactsPopUp")
            },500)
        },
        closeContactsModal(){
            this.openContactsPopUp = false;
        },
        closeContactsModal(){
            this.openContactsPopUp = false;
        },
        addCustomer(newTag) {
            const element = newTag;
            if (String(element).match(this.email_regex)) {
                this.optionsRecipients.push({
                    email: element
                });
                this.createJson.recipient_email.push({
                    email: element
                });
            } else {
                this.$awn.success("As Your Email ID Was Not Valid It is Removed");
                this.invalidEmail = true;
                return;
            }
        },
        removeTag(tag){
            this.createJson.recipient_details.forEach((el,index)=>{
                if(el.id == tag.id){
                    this.createJson.recipient_details.splice(index,1)
                }
            })
        },
        // validateData(){
        //     this.$validator.validateAll().then(result =>{
        //         if(this.createJson.end_date == ""){
        //             this.is_end_date = true;
        //         }
        //         if(this.createJson.end_time == ""){
        //             this.is_end_time = true;
        //         }
        //         if(this.createJson.sms_url == ""){
        //             this.is_sms_url = true;
        //         }
        //         if(result){
        //             this.saveAndSend();
        //         }
        //     })
        // },
        async loadCampaignDetails(){
            let response = await this.getCampaignDetails(this.$route.params.id)
            this.campaign_details = response.response
            this.createJson.campaign_name = this.campaign_details.name
            this.createJson.author_name = this.campaign_details.author_name
            this.createJson.author_email = this.campaign_details.author_email
            this.createJson.industry_type = this.campaign_details.industry_type
            this.createJson.campaign_type = this.campaign_details.type.toUpperCase()
            this.createJson.start_date = this.campaign_details.start_date
            this.createJson.start_time = this.campaign_details.start_time
            this.createJson.end_date = this.campaign_details.end_date
            this.createJson.end_time = this.campaign_details.end_time
            this.createJson.recurrence_days = this.campaign_details.recurrence ? this.campaign_details.recurrence[0].toUpperCase() + this.campaign_details.recurrence.substring(1) : ""
            this.createJson.currency = this.campaign_details.budget.symbol
            this.createJson.budget = this.campaign_details.budget.value
            this.createJson.add_description = this.campaign_details.description
            this.createJson.recipient_details = this.campaign_details.recipients
            this.createJson.sms_url = this.campaign_details.message_details.url
            this.createJson.add_message = this.campaign_details.message_details.message
            this.campaign_status = this.campaign_details.status
        },
        async saveAndSend(){
            //this.approveButtonDisable = true
            let temp_data = []
            if (this.$route.params.id) {
                this.createJsonData.recipient_details.forEach((el) => {
                    if(el.phone.phone_number == "" || el.phone.phone_number){
                        temp_data.push({
                            email: el.email,
                            name: el.name,
                            phone: el.phone.phone_number,
                            id: el.id,
                            source: el.source
                        })
                    } else {
                        temp_data.push({
                            email: el.email,
                            name: el.name,
                            phone: el.phone,
                            id: el.id,
                            source: el.source
                        })
                    }
                })
            } else {
                this.createJsonData.recipient_details.forEach((el) => {
                    temp_data.push({
                        email: el.email,
                        name: el.name,
                        phone: el.phone.phone_number,
                        id: el.id,
                        source: el.source
                    })
                })
            }
            try {
                let params = {
                    "budget": {
                        "symbol": this.createJsonData.currency,
                        "value": this.createJsonData.budget
                    },
                    "description": this.createJsonData.description,
                    "start_date": this.createJsonData.start_date,
                    "start_time": this.createJsonData.start_time,
                    "end_date": this.createJsonData.end_date,
                    "end_time": this.createJsonData.end_time,
                    "industry_type": this.createJsonData.industry_type,
                    "message_details": {
                        "message": this.createJsonData.message,
                        "url": this.createJsonData.sms_url
                    },
                    "name": this.createJsonData.campaign_name,
                    "recipients": temp_data,
                    "recurrence": this.createJsonData.recurrence_days.toLowerCase(),
                    "template_details": {
                        "address": {
                            "address_type": "",
                            "building_number": "",
                            "city": "",
                            "country": "",
                            "latitude": 20,
                            "longitude": 77,
                            "state": "",
                            "street": "",
                            "township": "",
                            "zip_code": ""
                        },
                        "info": {
                            "headline_content": "",
                            "headline_name": "",
                            "topic_name": "",
                            "url": "",
                            "url_headline": ""
                        },
                        "social_media": {
                            "facebook": "",
                            "instagram": "",
                            "linkedin": "",
                            "twitter": ""
                        },
                        "images": {
                            "banner_image": "",
                            "logo": ""
                        },
                    },
                    "template_type": "sms",
                    "type": "sms",
                    "id": this.$route.params.id || ""
                }
                if (this.$route.params.id) {
                    var response = await this.updateCampaignsByID(params)
                } else {
                    var response = await this.createCampaignData(params)
                }
                if (response.status_id == 1) {
                    this.success_msg = response.message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.$router.push({
                            path: '/campaign/sms/campaignSmsListView/'
                        })
                        this.$refs.success_modal.close();
                    }, 3000);
                } else {
                    this.warning_msg = response.reason
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            } catch (error) {
                this.warning_msg = error.reason
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        async searchCustomerInside(key) {
            if (key) {
                this.search_term = key;
            }
            let params = {
                skip: this.skip,
                limit: this.limit,
                search_key: this.search_term,
                company_id: this.loggedInUser.company_id
            };
            let res = await this.getAssigned(params);
            this.optionsRecipients = res.response;
            this.count = 0;
            this.isLoading = false;
        },
        async reachedEndOfListCustomer(reached) {
            this.isVisible = reached;
            if (reached) {
                if (this.scrollableCustomer == false) {
                    this.isLoading = true;
                    let res = await this.getAssigned({
                        skip: this.optionsRecipients.length,
                        limit: 10,
                        search_key: this.search_term,
                        company_id: this.loggedInUser.company_id
                    });
                    if (res.response.length > 0) {
                        let tempFiles = res.response;
                        tempFiles.forEach(el => {
                            this.optionsRecipients.push(
                                el);
                        });
                        this.count += res.response.length;
                        this.isLoading = false;
                    } else {
                        this.scrollableCustomer = true;
                        this.isLoading = false;
                    }
                    this.isLoading = false;
                }
            }
        },
    },
    mounted(){
        this.createJson.author_name = this.loggedInUser.full_name;
        this.createJson.author_email = this.loggedInUser.login_id;
        this.createJson.currency = this.loggedInUser.currency.symbol;
        if(this.$route.params.id){
            this.campaign_id = this.$route.params.id
            this.loadCampaignDetails()
        }
    },
    computed: {
        loggedInUser() {
            return this.$store.state.loggedInUser;
        },
        current_date() {
            var date = new Date();
            date.setDate(date.getDate() + 1);
            return date;
        },
        userPermissions(){
            return this.$store.getters.userPermissions;
        }
    },
    created() {
    },
}
</script>
<style scoped>
    .diginew-multiselect-longshort{
        min-height: 8em !important;
        max-height: auto !important;
        display: block;
        padding: 2px 40px 0 6px !important;
        border-radius: 6px;
        background: transparent;
        font-size: 14px !important;
    }
    .add-new-field{
        background-color: transparent;
        outline: 0 none !important;
    }
    .main-div {
        background: #fff;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .create-company-container {
        background-color: #fff;
        padding: 0px 0 0px 0;
        border-radius: 5px;
    }

    .create-company-header {
        padding: 9.9px 15px;
        background-color: #00448b;
    }
    .input-label {
        font-weight: 600;
        line-height: 1.5;
        letter-spacing: 0.39px;
        text-align: left;
        color: #005dae;
        padding: 0 0 6px 12px;
        font-size: 14px;
    }
    .input-field {
        border-radius: 6px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px;
        color: #000;
        font-size: 14px!important;
        font-weight: 600;
    }
    .input-width {
        border-radius: 5px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px !important;
    }
    .btn-new-cancel {
        color: #005dae;
        background-color: #fff;
        border-radius: 5px;
        text-transform: none;
        font-weight: 500;
        border: 2px solid #005dae;
        line-height: 30px;
        box-shadow: none;
    }
    .btn-new-reject {
        color: #fff;
        background-color: #E64646;
        border-radius: 5px;
        text-transform: none;
        font-weight: 500;
        border: 2px solid #E64646;
        line-height: 30px;
        box-shadow: none;
    }
    .btn-new-save {
        border: 2px solid #005dae;
        line-height: 30px;
        border-radius: 5px;
        background-color: #005dae;
    }
    .btn-new-approve {
        border: 2px solid #1f8122;
        color:#fff;
        line-height: 30px;
        border-radius: 5px;
        background-color: #1f8122;
        text-transform: capitalize;
    }
    .mx-datepicker.date-white .mx-input-wrapper input.mx-input {
        height: 32px !important;
        color: #fff !important;
        font-weight: 600 !important;
        font-size: 13px !important;
    }
    .mx-input {
        /* border-bottom: 1px solid #fff !important; */
        display: inline-block;
        height: 0px !important;
    }
    .v-hidden {
        visibility: hidden;
    }

    i,
    [class^="icon-"] {
        line-height: 0px !important;
    }
    .text-green {
        color: #008a63 !important;
    }
    .pointer-event {
        background-color: #fff !important;
    }
    .input-date-position{
        position: relative;
        bottom: 7px;
    }
    .text-secondary {
        color: #00448b !important;
    }
    .select-width{
        width:80px;
        height:40px;
        border-radius: 5px;
    }
    .icon-width {
        width: 20px;
        height: 20px;
    }
    .icon-color {
        color:#ff9a06
    }
    .text-line {
        text-decoration :none !important;
    }
    .w-200px{
        max-width: 230px;
    }
    .recipients-box {
        height: 8em;
        width: 100%;
    }
    .add-button{
        color: #226BD3;
        background-color: #fff;
        font-weight: 600;
        cursor: pointer;
    }
    .rec-count{
        margin-top: -70px;
    }
    .custom__tag{
        cursor: default;
    }
    .text-new-danger{
        color: #e64646 !important;
    }

    .text-pending{
        color: #E4A045 !important;
    }
    .dis-bg-color{
        background-color: #fff;
    }
    .text-approved{
        color: #078A63 !important
    }
</style>



// WEBPACK FOOTER //
// src/components/Campaign/Sms/ApproveSmsCampaign.vue